module.exports = __webpack_public_path__ + "static/img/model_two.9dd8704.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/model_two.jpg
// module id = /bUM
// module chunks = 0